export class RankingStats{
    public static META_USER_ID:String = "USER_ID";
    public static META_USER_POSITION:String = "USER_POSITION";
    public static META_USERS_COUNT:String = "USERS_COUNT";
    public static META_START_POSITION:String = "START_POSITION";

    public static TIME_TO_END_TOURNAMENT:String = "TIME_TO_END_TOURNAMENT";
    public static META_VIEWPORT_CREATION_TIME:String = "META_VIEWPORT_CREATION_TIME";
    
    public pushData(data:any):void  {
        this.dataProvider.push(data);
    }   
    public clearData():void{
        this.dataProvider = [];
    }
    public set(i:number, obj:any):void{
        this.dataProvider[i] = obj;
    }

    private dataProvider:Array<any>;
    playerPosition:number;
    playerPositionString:string;
    totalPlayers:number;
    startPosition:number;
    rowCount:number;
    
    moreEnabled:boolean;
    lessEnabled:boolean;
    jumpToMeVisible:boolean;
    pipeName:string;
    
    viewportCreationTime:number;
    tournamentEndTime:number;
    
    windowSize:number;
    
    constructor( pipeName:string, dataProvider:Array<any> = null, windowSize:number = 9, rowCount:number = 8 ) 
    {
        if ( dataProvider == null ) {
            this.dataProvider = new Array<any>();
        }else{
            this.dataProvider = dataProvider;
        }
        this.playerPosition = -1;
        this.playerPositionString = "-";
        this.windowSize = windowSize;
        this.pipeName = pipeName;
        this.rowCount = rowCount;
    }		
    
    public addMetas( name:Array<string>, value:Array<string> ):void{
        for ( let i:number = 0; i < name.length; i++ ) {
            this.addMeta( name[i], value[i] );
        }
    }
    
    private updateButtonVisibility():void {
        this.moreEnabled = this.startPosition + this.windowSize < this.totalPlayers;
        this.lessEnabled = this.startPosition > 0;
        this.jumpToMeVisible =  this.playerPosition >= 0 && !(this.playerPosition >= this.startPosition && this.playerPosition < this.startPosition + this.windowSize);
    }
    
    public addMeta( name:string, value:string ):void{
        if ( RankingStats.META_USER_ID == name ) {
            
        }
        if ( RankingStats.META_USER_POSITION == name ) {
            this.playerPosition = parseInt( value );
            this.playerPositionString = value;
        }
        if ( RankingStats.META_USERS_COUNT == name ) {
            this.totalPlayers = parseInt( value );				
        }
        if ( RankingStats.META_START_POSITION == name ) {
            this.startPosition = parseInt( value );
        }
        
        if ( RankingStats.TIME_TO_END_TOURNAMENT == name ) {
            this.tournamentEndTime = parseFloat( value );
        }
        if ( RankingStats.META_VIEWPORT_CREATION_TIME == name ) {
            this.viewportCreationTime = parseFloat( value );
        }
        
        this.updateButtonVisibility();
    }
    
    public recalculateEndTime():number{
        return this.tournamentEndTime - this.viewportCreationTime;
    }
    
    public removeMetas( names:Array<string> ):void {
        for ( let name of names ){
            this.removeMeta( name );
        }
    }
    public removeMeta( name:string ):void{
        if ( RankingStats.META_USER_ID == name ) {
            
        }
        if ( RankingStats.META_USER_POSITION == name ) {
            this.playerPosition = -1;
            this.playerPositionString = "-";
        }
        if ( RankingStats.META_USERS_COUNT == name ) {
            this.totalPlayers = 0;
        }
        if ( RankingStats.META_START_POSITION == name ) {
            this.startPosition = 0;
        }
        this.updateButtonVisibility();
    }

/*

    public static META_USER_ID:string = "USER_ID";
    public static META_USER_POSITION:string = "USER_POSITION";
    public static META_USERS_COUNT:string = "USERS_COUNT";
    public static META_START_POSITION:string = "START_POSITION";

    dataProvider:Array<any>;
    
    playerPosition:number;
    playerPositionString:String;
    totalPlayers:number;
    startPosition:number;
    
    moreEnabled:boolean;
    lessEnabled:boolean;
    jumpToMeVisible:boolean;
    
    windowSize:number;
    
    constructor( dataProvider:Array<any> = null, windowSize:number = 9 ) 
    {
        if ( dataProvider == null ) {
            this.dataProvider = new Array<any>();
        }else{
            this.dataProvider = dataProvider;
        }
        this.playerPositionString = "-";
        this.windowSize = windowSize;
    }		
    
    public addMetas( name:Array<string>, value:Array<string> ):void{
        for ( var i:number = 0; i < name.length; i++ ) {
            this.addMeta( name[i], value[i] );
        }
    }
    
    public addMeta( name:string, value:string ):void{
        if ( RankingStats.META_USER_ID == name ) {
            
        }
        if ( RankingStats.META_USER_POSITION == name ) {
            this.playerPosition = parseInt( value );
            this.playerPositionString = value;
        }
        if ( RankingStats.META_USERS_COUNT == name ) {
            this.totalPlayers = parseInt( value );				
            this.moreEnabled = this.startPosition + this.windowSize < this.totalPlayers;
            this.lessEnabled = this.startPosition > 0;
            this.jumpToMeVisible = !(this.playerPosition > this.startPosition && this.playerPosition < this.startPosition + this.windowSize);
        }
        if ( RankingStats.META_START_POSITION == name ) {
            this.startPosition = parseInt( value );
            this.moreEnabled = this.startPosition + this.windowSize < this.totalPlayers;
            this.lessEnabled = this.startPosition > 0;
            this.jumpToMeVisible = !(this.playerPosition > this.startPosition && this.playerPosition < this.startPosition + this.windowSize);
        }
    }
    
    public removeMetas( names:Array<string> ):void {
        for ( let name of names ){
            this.removeMeta( name );
        }
    }
    public removeMeta( name:string ):void{
        if ( RankingStats.META_USER_ID == name ) {
            
        }
        if ( RankingStats.META_USER_POSITION == name ) {
            this.playerPosition = -1;
            this.playerPositionString = "-";
        }
        if ( RankingStats.META_USERS_COUNT == name ) {
            this.totalPlayers = 0;
        }
        if ( RankingStats.META_START_POSITION == name ) {
            this.startPosition = 0;
        }
    }
    */
}